// extracted by mini-css-extract-plugin
export default {"root":"Dropzone_root__LWId+"};